import React from 'react'

const noop = () => {}

const initialState = {
  id: undefined,
  changeSkin: noop,
  supportedApps: [
    // {
    //   id: 'yoti',
    //   name: 'Yoti',
    // },
    // {
    //   id: 'easyid',
    //   name: 'Post Office EasyID',
    // },
    // {
    //   id: 'smartid',
    //   name: 'Lloyds Bank Smart ID',
    // },
  ]
}

const SkinContext = React.createContext(initialState)

export default SkinContext
